import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { MemberCreatePage } from '@/features/access/members/member-create-page';
import { ConsoleShell } from '@/features/shell/console-shell';

export const Route = createFileRoute('/$tenant/members/new')({ component: NewMemberRoute });

function NewMemberRoute() {
  const { tenant } = Route.useParams();
  const { t } = useTranslation();
  return (
    <ConsoleShell
      tenantId={tenant}
      activeItem="members"
      crumbs={[{ label: t('access.members.title') }, { label: t('access.members.newTitle') }]}
    >
      <MemberCreatePage tenantId={tenant} />
    </ConsoleShell>
  );
}
